export default __webpack_public_path__ + "static/media/tamato1.0a00c977.png";